import { FeaturesEnum } from '@services/Features/FeaturesEnum';

export const DEFAULT_KSS_FEATURES: { [key: string]: boolean } = {
  [FeaturesEnum.StoryPerformance_KlmLink]: true,
  [FeaturesEnum.StoriesList_KlmLink]: true,
  [FeaturesEnum.StoriesList_Performance]: true
};
